export default __webpack_public_path__ + "static/media/upgrade-plan.fce42936.png";